import { render } from "./Month.vue?vue&type=template&id=27d09fe4&scoped=true"
import script from "./Month.vue?vue&type=script&lang=ts"
export * from "./Month.vue?vue&type=script&lang=ts"

import "./Month.vue?vue&type=style&index=0&id=27d09fe4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-27d09fe4"

export default script